import { useEffect, useState } from "react";
import {
  CMSIcon,
  GameModuleIcon,
  PlayerModuleIcon,
  UserModuleIcon,
} from "@/assets/icons/admin";
import GameModuleTabs from "@/components/admin/gamemodule";
import PlayerModuleTabs from "@/components/admin/playermodule";
import UserModuleTabs from "@/components/admin/usermodule";
import { Tab, Tabs } from "@nextui-org/react";
import { useNavigate } from "react-router-dom";
import useUserStore from "@/stores/authentication/store";
import CMSModuleTabs from "@/components/admin/cmsmodule";
import ReferralIcon from "@/assets/icons/admin/referral/referral";
import ReferralModule from "@/components/admin/referralmodule";
import BonusModuleTab from "@/components/admin/bonusmodule";
import GgrModule from "@/components/admin/ggrmodule";
import TransactionModuleTabs from "@/components/admin/transactionmodule";
import { LogsIcon, Wallet } from "lucide-react";
import HotWalletList from "@/components/admin/hotwallet";
import DepositsManagement from "@/components/admin/deposits";
import { PlayerBalances } from "@/components/admin/balances";
import { ActivityLogs } from "@/components/admin/activitylog";
import { ReportModuleTabs } from "@/components/admin/reportmodule";
import Dashboard from "@/components/admin/dashboard";
import { DepositBonusModuleTabs } from "@/components/admin/depositbonus";

const Admin = () => {
  const navigate = useNavigate();
  const userData = useUserStore((state) => state.data);
  const [selectedTab, setSelectedTab] = useState("dashboard");

  useEffect(() => {
    if (userData && userData.role) {
      const isAdmin =
        userData && userData.role?.toLowerCase().includes("admin");
      if (!isAdmin) navigate("/404");
    }
  }, [userData, userData.role, navigate]);

  return (
    <div className="inline-container admin-bg flex h-full flex-col justify-start text-white">
      <div className="mb-4 justify-between overflow-x-auto whitespace-nowrap sm:mb-0 sm:mr-4 ">
        <Tabs
          selectedKey={selectedTab}
          onSelectionChange={(key) => setSelectedTab(key as string)}
          classNames={{
            base: "overflow-x-scroll",
            tab: "py-6 px-12 max-w-40 text-sm font-normal bg-white/5 rounded-lg sm:mt-2",
            cursor: ["admin-module"],
            tabList: ["flex md:w-fit"],
          }}
          fullWidth
          variant="light"
          className="justify-between"
        >
          <Tab
            key="dashboard"
            title={
              <div className="flex items-center space-x-2">
                <img
                  src={`/assets/admin/dashboard/icon.svg`}
                  alt="back"
                  className="h-[20px] w-[20px]"
                />
                <span>Dashboard</span>
              </div>
            }
          >
            <div className="mt-4 sm:mt-0">
              <Dashboard setSelectedTab={setSelectedTab} />
            </div>
          </Tab>
          <Tab
            key="user-module"
            title={
              <div className="flex items-center space-x-2">
                <UserModuleIcon />
                <span>User Module</span>
              </div>
            }
          >
            <div className="mt-4 sm:mt-0">
              <UserModuleTabs />
            </div>
          </Tab>
          <Tab
            key="report-module"
            title={
              <div className="flex items-center space-x-2">
                <GameModuleIcon />
                <span>Report Module</span>
              </div>
            }
          >
            <div className="mt-4 sm:mt-0">
              <ReportModuleTabs />
            </div>
          </Tab>
          {/* <Tab */}
          {/*   key="bonus-module" */}
          {/*   title={ */}
          {/*     <div className="flex items-center space-x-2"> */}
          {/*       <UserModuleIcon /> */}
          {/*       <span>Bonus Module</span> */}
          {/*     </div> */}
          {/*   } */}
          {/* > */}
          {/*   <div className="mt-4 sm:mt-0"> */}
          {/*     <BonusModuleTab /> */}
          {/*   </div> */}
          {/* </Tab> */}
          <Tab
            key="transactions-module"
            title={
              <div className="flex items-center space-x-2">
                <CMSIcon />
                <span>Transactions</span>
              </div>
            }
          >
            <div className="mt-4 sm:mt-0">
              <TransactionModuleTabs />
            </div>
          </Tab>
          <Tab
            key="player-module"
            title={
              <div className="flex items-center space-x-2">
                <PlayerModuleIcon />
                <span>Player Module</span>
              </div>
            }
          >
            <div className="mt-4 sm:mt-0">
              <PlayerModuleTabs />
            </div>
          </Tab>
          <Tab
            key="cms-module"
            title={
              <div className="flex items-center space-x-2">
                <CMSIcon />
                <span>CMS</span>
              </div>
            }
          >
            <div className="mt-4 sm:mt-0">
              <CMSModuleTabs />
            </div>
          </Tab>
          <Tab
            key="referral-module"
            title={
              <div className="flex items-center space-x-2">
                <ReferralIcon />
                <span>Referral</span>
              </div>
            }
          >
            <div className="mt-4 sm:mt-0">
              <ReferralModule />
            </div>
          </Tab>
          <Tab
            key="ggr-module"
            title={
              <div className="flex items-center space-x-2">
                <UserModuleIcon />
                <span>GGR Module</span>
              </div>
            }
          >
            <div className="mt-4 sm:mt-0">
              <GgrModule />
            </div>
          </Tab>

          <Tab
            key="hot-wallet-module"
            title={
              <div className="flex items-center space-x-2">
                <Wallet />
                <span>Hot Wallet</span>
              </div>
            }
          >
            <div className="mt-4 sm:mt-0">
              <HotWalletList />
            </div>
          </Tab>

          <Tab
            key="deposits-module"
            title={
              <div className="flex items-center space-x-2">
                <Wallet />
                <span>Deposits</span>
              </div>
            }
          >
            <div className="mt-4 sm:mt-0">
              <DepositsManagement />
            </div>
          </Tab>

          <Tab
            key="balances-module"
            title={
              <div className="flex items-center space-x-2">
                <Wallet />
                <span>Balances</span>
              </div>
            }
          >
            <div className="mt-4 sm:mt-0">
              <PlayerBalances />
            </div>
          </Tab>

          <Tab
            key="logs-module"
            title={
              <div className="flex items-center space-x-2">
                <LogsIcon />
                <span>Logs</span>
              </div>
            }
          >
            <div className="mt-4 sm:mt-0">
              <ActivityLogs />
            </div>
          </Tab>
          <Tab
            key="deposit-bonus-module"
            title={
              <div className="flex items-center space-x-2">
                <UserModuleIcon />
                <span>Deposit Bonus</span>
              </div>
            }
          >
            <div className="mt-4 sm:mt-0">
              <DepositBonusModuleTabs />
            </div>
          </Tab>
        </Tabs>
      </div>
    </div>
  );
};

export default Admin;
